const DANGEROUS_PROTOCOL = /^(javascript|data|vbscript|file|blob):/i;
const SCHEME = /^([a-zA-Z][a-zA-Z\d+\-.]*):/;
const ALLOWED_SCHEMES = new Set(['http', 'https', 'mailto', 'tel']);

const isC0OrWhitespace = (char) => {
    const code = char.charCodeAt(0);
    return code <= 32 || code === 127;
};

const compact = (value) =>
    Array.from(String(value ?? '').trim())
        .filter((char) => !isC0OrWhitespace(char))
        .join('');

const isDangerousCandidate = (value) => DANGEROUS_PROTOCOL.test(value);

/**
 * Restrict markdown href/src values so javascript:/data: URLs cannot reach
 * <a> or <img>. Relative paths and in-app hashes (#fm_report, /#accounts/1) stay.
 */
export const sanitizeMarkdownUrl = (value) => {
    if (value == null) return '';

    const url = String(value).trim();
    if (!url) return '';

    const candidates = [url, compact(url)];
    try {
        const decoded = decodeURIComponent(url);
        candidates.push(decoded, compact(decoded));
    } catch {
        // Malformed percent-encoding is not a bypass; keep checking the raw value.
    }

    if (candidates.some(isDangerousCandidate)) return '';

    const schemeMatch = compact(url).match(SCHEME);
    if (schemeMatch && !ALLOWED_SCHEMES.has(schemeMatch[1].toLowerCase())) {
        return '';
    }

    return url;
};
